import { useEffect } from "react";
import axios from "axios";
import { Navbar, Footer } from "@/components/layout";
import {
  HeroSection,
  QuickLinksSection,
  PathsSection,
  StatsSection,
  HowItWorksSection,
  CTASection,
  MobileAppSection
} from "@/components/sections";
import API from "@/utils/api";

const Home = () => {
  useEffect(() => {
    axios.get(`${API}/`).catch(console.error);
  }, []);

  return (
    <div className="min-h-screen" data-testid="home-page">
      <Navbar />
      <HeroSection />
      <QuickLinksSection />
      <PathsSection />
      <StatsSection />
      <HowItWorksSection />
      <CTASection />
      <MobileAppSection />
      <Footer />
    </div>
  );
};

export default Home;
